import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { api } from '../lib/api';

export default function Breakdown() {
  const { idToken } = useAuth();
  const [zip, setZip] = useState('');
  const [price, setPrice] = useState('4.2599');
  const [data, setData] = useState<any>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api('/api/me', { token: idToken! }).then(m => setZip(m.zip));
  }, []);

  async function run() {
    setErr(null);
    try {
      const r = await api('/api/tax/breakdown', { method: 'POST', token: idToken!, body: JSON.stringify({ zip, price: parseFloat(price) }) });
      setData(r);
    } catch (e: any) { setErr(e.message); }
  }

  return (
    <div className="container">
      <div className="card" style={{ marginBottom: 14 }}>
        <h3>Transparent price breakdown</h3>
        <div className="row">
          <div><label>Zip</label><input value={zip} onChange={e => setZip(e.target.value)} maxLength={5} /></div>
          <div><label>Posted price ($/gal)</label><input value={price} onChange={e => setPrice(e.target.value)} /></div>
          <button onClick={run}>Break down</button>
        </div>
        {err && <p className="pill bad">{err}</p>}
      </div>

      {data && (
        <div className="card">
          <h3>{data.location.city}, {data.location.state} — ${data.breakdown.posted.toFixed(4)}/gal</h3>
          <table>
            <thead><tr><th>Component</th><th style={{ textAlign: 'right' }}>$/gal</th></tr></thead>
            <tbody>
              {data.breakdown.components.map((c: any, i: number) => (
                <tr className="breakdown-row" key={i}>
                  <td>
                    <span className={`pill ${kindClass(c.kind)}`} style={{ marginRight: 8 }}>{c.kind}</span>
                    {c.label}
                  </td>
                  <td>{(c.kind === 'wholesale' ? '' : '-') + '$' + c.amount.toFixed(4)}</td>
                </tr>
              ))}
              <tr className="breakdown-row total"><td>Total taxes &amp; fees</td><td>${data.breakdown.totalTax.toFixed(4)}</td></tr>
              <tr className="breakdown-row total"><td>Wholesale + retailer margin</td><td>${data.breakdown.wholesalePlusMargin.toFixed(4)}</td></tr>
              <tr className="breakdown-row total"><td>Posted retail</td><td>${data.breakdown.posted.toFixed(4)}</td></tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function kindClass(k: string) {
  switch (k) {
    case 'federal': return 'bad';
    case 'state': return 'muted';
    case 'county': return 'muted';
    case 'fee': return 'muted';
    case 'wholesale': return 'good';
    default: return 'muted';
  }
}
